export var INITIAL_SEARCH_PAGE_FILTERS_DATA = {
    filtersResponse: undefined,
    legacyFiltersResponse: undefined,
    loading: true,
    isError: false,
    error: undefined
};
